module.exports = __webpack_public_path__ + "assets/icons/sessions-logo.8940b681049ac458f0bc959ca0a8e174.svg";